// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/book-type.js';

import { paths } from '../generated/book-type';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('book-type', Original, paths);
